module.exports = __webpack_public_path__ + "static/media/Ekta-Doshi.c7dab4d4.png";